import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText, IonDatetime, IonRefresher, IonRefresherContent } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect} from 'react';

import {DateRange} from '../../../zInternal_Features/merchant/components/DateRange'

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import {ViewEstimateListModal} from '../components/Modal_ViewEstimateList';
import { ViewConsultationListModal} from '../components/Modal_ViewConsultationList';
import { ViewProjectListModal} from '../components/Modal_ViewActiveProjectList';

import { PushNotifiPushNotificationSchema, PushNotifications, Token, ActionPerformed } from '@capacitor/push-notifications';
import { Toast } from "@capacitor/toast";


export function Tab_Projects(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    //alert('In CheckIn_CheckOutSlides')
    //alert(authenticatedMerchent_context.acctID);
    //alert(authenticatedMerchent_context.accessRights);
    //alert(authenticatedMerchent_context.accessRights[0]);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate()-7)));
    let [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate()+1)));

    let [startDate_display, setStartDate_display] = useState(false);
    let [endDate_display, setEndDate_display] = useState(false);

    let [estimatesData, setEstimateData] = useState(null);
    let [consulatationData, setConsultationData] = useState(null);
    let [activeOrderData, setActiveOrderData] = useState(null);

    let [searchGuestData, setSearchGuestData] = useState(null);

    let [viewEstimatesModal, setViewEstimatesModal] = useState(false);
    let [viewConsultationsModal, setViewConsultationsModal] = useState(false);
    let [viewActiveProjectsModal, setViewActiveProjectsModal] = useState(false);


    let [notifications, setnotifications] = useState([]);

    function searchGuestDataHandler(e) {
        
        setSearchGuestData(e.target.value);
    }

    function reloadDates(event)
    {

         //alert('In Tab Overview UseEffect');
        //alert(authenticatedMerchent_context.accessRights[0]);
        // alert(JSON.parse(authenticatedMerchent_context.feature).employeeHR);
        // alert(JSON.parse(authenticatedMerchent_context.feature).jobs);

        //alert(startDate);
        //alert(endDate);

        let formData = new FormData();
        let tracker = 0;

        //formData.append('Tracker', 74001);
        /*formData.append('user', acctID);
        formData.append('xStartDateRange', startDate.toISOString().substr(0, 10));
        formData.append('xEndDateRange', endDate.toISOString().substr(0, 10));


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }*/

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: "74100_proService",
                user: acctID,
                xStartDateRange: event[0],
                xEndDateRange: event[1],
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {


            let rows = res.toString().split('~~~');
            let rowLength = rows.length;

                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setEstimateData(cols[0]);
                    setConsultationData(cols[1]);
                    setActiveOrderData(cols[2]);

                }
                       
                    authenticatedMerchent_context.changeStartDateRange(event[0]);
                    authenticatedMerchent_context.changeEndDateRange(event[1]);

                    setStartDate(new Date(event[0]));
                    setEndDate(new Date(event[1]));

                    setStartDate(new Date(event[0]));
                    setEndDate(new Date(event[1]));

            })

    }

    function handleRefresh(event)
    {
        // Optional: Delay to show the spinner briefly
        setTimeout(() => {
            event.detail.complete();   // Stop the spinner
            window.location.reload();  // Reload the entire app
        }, 500);
    }

    useEffect(() => {

        reloadDates([startDate.toISOString().substr(0, 10), endDate.toISOString().substr(0, 10)]);

   }, []);
    //alert('In CheckInCheckOut');
    //alert(notifications);
    //alert(notifications.length);
    //alert(authenticatedMerchent_context.accessRights[0]);


    return (
        <React.Fragment>
        {notifications.length !== 0 &&
        <IonList>
            {notifications.map((notif) =>
                <IonItem key={notif.id}>
                    <IonLabel>
                        <IonText>
                            <h3 className="notif-title">{notif.title}</h3>
                        </IonText>
                        <p>{notif.body}</p>
                    </IonLabel>
                </IonItem>
            )}
            </IonList>}

        <IonContent  className='appContent'>
            <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                <IonRefresherContent
                pullingText="Pull to refresh the app"
                refreshingSpinner="circles"
                refreshingText="Refreshing app..."
                />
            </IonRefresher>
            <IonItem>
                <IonGrid>
                        <DateRange setDate={(e) => reloadDates(e)} data={{
                        startDate: startDate, 
                        endDate: endDate
                        }}></DateRange>
                </IonGrid>
            </IonItem>
            <IonGrid >
                <IonRow>
                    <IonCol>
                        <h3>Request for Estimate</h3>
                        <p > {estimatesData} </p>
                        <IonButton onClick={() => setViewEstimatesModal(true)}> View </IonButton>
                    </IonCol>
                    <IonCol>
                        <h3>Consultations In-Progress</h3>
                        <p > {consulatationData} </p>
                        <IonButton onClick={() => setViewConsultationsModal(true)}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <h3>Active Projects</h3>
                        <p > {activeOrderData} </p>
                        <IonButton onClick={() => setViewActiveProjectsModal(true)}> View </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>


            {viewEstimatesModal == true && <ViewEstimateListModal openModal={ viewEstimatesModal } closeModal={() => setViewEstimatesModal(false)} startDate={startDate} endDate={endDate}></ViewEstimateListModal>}
            {viewConsultationsModal == true && <ViewConsultationListModal openModal={ viewConsultationsModal } closeModal={() => setViewConsultationsModal(false)} startDate={startDate} endDate={endDate}></ViewConsultationListModal>}
            {viewActiveProjectsModal == true && <ViewProjectListModal openModal={ viewActiveProjectsModal } closeModal={() => setViewActiveProjectsModal(false)} startDate={startDate} endDate={endDate}></ViewProjectListModal>}


        </IonContent>
        </React.Fragment>
    )
    //}   
}